__turbopack_context__.v({
  "banner": "BpiLinkBanner-module__X_NLTG__banner",
  "label": "BpiLinkBanner-module__X_NLTG__label",
});
